import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Flame } from "lucide-react";

export default function ForgeFridayBanner() {
  const [active, setActive] = useState(false);
  useEffect(() => { api.get("/config/public").then((r) => setActive(!!r.data.forge_friday_active)); }, []);
  if (!active) return null;
  return (
    <div data-testid="forge-friday-banner" className="relative overflow-hidden border-b border-[#FF4500]/40 bg-[#FF4500] text-black">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-2 flex items-center justify-center gap-3 font-mono text-xs uppercase tracking-[0.25em]">
        <Flame className="h-4 w-4 shrink-0" />
        <span className="font-bold">MeloCraft Friday</span>
        <span className="hidden sm:inline opacity-80">· 100% of every purchase goes to the artist. No platform cut. Today only.</span>
        <span className="sm:hidden opacity-80">· 100% to artists today</span>
      </div>
    </div>
  );
}
